<template>
  <!-- Create a navbar that will be called and utilized in every component page -->
  <nav class="navbar is-black">
    <div class="navbar-brand">
      <a class="navbar-item" href="http://www.knosishealth.com" title="KNOSIS Website Home">
        <img src="../assets/knosisTRANSPARENT.png" alt="KNOSIS">
      </a>
      <a class="navbar-item" @click="showDeviceSyncModal = true">SYNC DEVICE</a>
      <div class="navbar-burger burger" @click="showNav = !showNav" :class="{ 'is-active': showNav }">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': showNav }">
      <div class="navbar-start">
      </div>

      <div class="navbar-end">
        <br><br><br><a class="navbar-item is-active" @click="goToHomePage">HOME</a>
        <a class="navbar-item is-active" @click="goToChallengePage">CHALLENGE</a>
        <a class="navbar-item is-active" @click="goToAvatarPage">AVATAR</a>
        <a class="navbar-item is-active" @click="goToFitnessHistoryPage">FITNESS HISTORY</a>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">More</a>
          <div class="navbar-dropdown is-boxed is-right">
            <a class="navbar-item" @click="goToInboxPage">INBOX <img v-if="newMessage" src="https://cdn3.iconfinder.com/data/icons/eightyshades/512/16_Exclamation-16.png"></a>
            <a class="navbar-item" @click="goToMarketPage">MARKET</a>
            <a class="navbar-item" @click="goToAccountPage">ACCOUNT</a>
            <hr class="navbar-divider">
            <a class="navbar-item" @click="logout">LOGOUT</a>
          </div>
        </div>
      </div>
    </div>
    <deviceSyncModal v-show="showDeviceSyncModal" @close="showDeviceSyncModal = false"></deviceSyncModal>
  </nav>
</template>

<script>
import * as firebase from 'firebase'
import deviceSyncModal from './Fitness/deviceSyncModal.vue'

export default {
  name: 'Navbar',
  data () {
    return {
      showNav: false,
      showDeviceSyncModal: false,
      newMessage: false,
    }
  },
  components: {
      deviceSyncModal: deviceSyncModal
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')  // call the logout method from the store
      this.$router.push({path: '/login'})
    },
    goToAccountPage() {
      this.showNav = false
      this.$router.push({path: '/account'})
      this.checkNewMessageReceived()
    },
    goToChallengePage() {
      this.showNav = false
      this.$router.push({path: '/challenge'})
      this.checkNewMessageReceived()
    },
    goToFitnessHistoryPage() {
      this.showNav = false
      this.$router.push({path: '/FitnessHistory'})
      this.checkNewMessageReceived()
    },
    goToHomePage() {
      this.showNav = false
      this.$router.push({path: '/home'})
      this.checkNewMessageReceived()
    },
    goToAvatarPage() {
      this.showNav = false
      this.$router.push({path: '/avatar'})
      this.checkNewMessageReceived()
    },
    goToInboxPage() {
      this.showNav = false
      this.dismissMessageAlert();
      this.newMessage = false;
      this.$router.push({path: '/inbox'})
      this.checkNewMessageReceived()
    },
    goToMarketPage() {
      this.showNav = false
      this.$router.push({path: '/market'})
      this.checkNewMessageReceived()
    },
    checkNewMessageReceived(){
      firebase.database().ref('users').child(this.$store.getters.user.id).child('newMessage').once('value')
       .then((data) => {
         this.newMessage = data.val()
       })
       if(this.newMessage){
         alert("You have received a new message!");
         this.dismissMessageAlert();
       }
    },

    dismissMessageAlert(){
      firebase.database().ref('users').child(this.$store.getters.user.id).
      update({
        newMessage: false,
      })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
    background-color: black;
    navbar-burger-color: black;
}
.navbar-burger {
  background-color: transparent;
  color: white;
  padding-top: 55px;
}
.navbar .navbar-brand .navbar-item {
  color: white;
  font-size: 14px;
  padding-top: 8%;
}
.navbar .navbar-menu .navbar-end .navbar-item:hover {
  color: purple;
}
@media only screen and (max-width: 1023px) {
  .navbar .navbar-brand .navbar-item {
    color: white;
    font-size: 14px;
    padding-top: 4%;
  }

  .burger-dropdown-position {
    margin-top: 40px;
    text-align: right;
  }

  /* Positions the burger to the upper right corner */
  .burger {
      position: relative;
      margin-top: -15px;
      padding-right: 55px;
      z-index: 100;
      display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue